var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMixcloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#5000FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4772 10.3635L17.5 11.8559V10.9375L15.7822 9.69388L17.4938 8.45025V7.52551L15.471 9.02423H15.2531L13.2427 7.52551V8.44388L14.9544 9.69388L13.249 10.9375V11.8559L15.2656 10.3635H15.4772ZM8.31328 10.0893H12.583V9.29209H8.31328V10.0893ZM6.71369 11.875H7.4917V7.5H5.95436L5.09544 11.6709H4.89627L4.03734 7.5H2.5V11.875H3.27801V8.22704L3.14108 7.70408H3.38382L4.28631 11.875H5.71784L6.61411 7.70408H6.86307L6.71992 8.22704V11.875H6.71369Z",
    fill: "#F3B2A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMixcloud);
export default __webpack_public_path__ + "static/media/icon_mixcloud.ccf2bb2b.svg";
export { ForwardRef as ReactComponent };